module.exports = __webpack_public_path__ + "img/img-4.e6799e80.png";